import { CONTEST_LIST_DATA, CONTEST_LIST_ERROR, CONTEST_LIST_FETCH } from './constants';
import { ContestListAction, ContestListState } from './types';

const initialState: ContestListState = {
    status: 'init',
    error: null,
    items: [],
};

export const contestListReducer = (state = initialState, action: ContestListAction): ContestListState => {
    switch (action.type) {
        case CONTEST_LIST_FETCH:
            return { ...state, status: 'loading', error: null };
        case CONTEST_LIST_DATA:
            return { ...state, status: 'success', items: action.payload };
        case CONTEST_LIST_ERROR:
            return { ...state, status: 'error', error: action.payload };
        default:
            return state;
    }
};


